import { render, staticRenderFns } from "./SubmissionStatus.vue?vue&type=template&id=5e5696ca&scoped=true&"
import script from "./SubmissionStatus.vue?vue&type=script&lang=js&"
export * from "./SubmissionStatus.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionStatus.vue?vue&type=style&index=0&id=5e5696ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5696ca",
  null
  
)

export default component.exports